import { a as w } from "./rpb-runtime-LB4O5ZMX.js";
import {
  confirmedWeight as f,
  weightChangePlan as E,
} from "./cart-return-weight.js";
import {
  CartErrorEvent as v,
  CartLinesUpdateEvent as d,
} from "@shopify/events";
var k = Object.defineProperty,
  l = w((e, t) => k(e, "name", { value: t, configurable: !0 }), "o"),
  h = new Set([
    "express-service-48-stunden",
    "hinversandlabel",
    "ruckversand-mit-sendungsverfolgung",
  ]),
  _ = "express-service-48-stunden",
  g = "ruckversand-mit-sendungsverfolgung",
  b = "_reparablo_express_prompted",
  u = (window.__reparabloPromptedCarts ||= new Set()),
  L = class extends HTMLElement {
    static {
      w(this, "E");
    }
    static {
      l(this, "CartServices");
    }
    #s = !1;
    #g = !1;
    #o;
    #observer;
    connectedCallback() {
      this.#observer = new MutationObserver(() => this.#j());
      this.#observer.observe(this.closest('cart-items-component') || this.parentElement, { childList: true, subtree: true });
      (this.addEventListener("submit", this.#b),
        this.addEventListener("click", this.#y),
        this.addEventListener("change", this.#E),
        this.addEventListener("change", this.#f),
        document.addEventListener("click", this.#n, !0),
        document.addEventListener("submit", this.#n, !0),
        this.#j(),
        this.#C());
    }
    disconnectedCallback() {
      this.#observer?.disconnect();
      (this.removeEventListener("submit", this.#b),
        this.removeEventListener("click", this.#y),
        this.removeEventListener("change", this.#E),
        this.removeEventListener("change", this.#f),
        document.removeEventListener("click", this.#n, !0),
        document.removeEventListener("submit", this.#n, !0),
        window.clearTimeout(this.#o));
    }
    #C = l(async () => {
      this.#a(!0);
      try {
        (window.__reparabloWeightChange &&
          (await window.__reparabloWeightChange),
          window.__reparabloCartNormalization ||
            (window.__reparabloCartNormalization = this.#T().finally(() => {
              window.__reparabloCartNormalization = null;
            })),
          await window.__reparabloCartNormalization);
        let e = await this.#i(),
          t = e.items.filter((i) => !h.has(this.#e(i))),
          a = f(e, this.#p());
        (this.#w(e),
          t.length > 0 && a
            ? (this.#a(!1), this.#x(e))
            : t.length === 0 && this.#a(!1));
      } catch (e) {
        (this.dataset.weightRequired === "true" &&
          document.documentElement.classList.add("reparablo-weight-pending"),
          this.#a(!1),
          this.#A(e, "Die Versandoptionen konnten nicht vorbereitet werden."));
      }
    }, "#initialize");
    #T = l(async () => {
      let e = await this.#i(),
        t = e.items.filter((n) => !h.has(this.#e(n))),
        a = e.items.filter((n) => h.has(this.#e(n)));
      if (t.length === 0) {
        if (a.length === 0) return;
        let n = Object.fromEntries(a.map((r) => [r.key, 0]));
        await this.#_(n, a, "remove");
        return;
      }
      if (e.attributes?.['Rückgabe'] === 'Vor Ort – kein Versand') {
        const shipping = a.filter(n => [g, 'hinversandlabel'].includes(this.#e(n)));
        if (shipping.length) await this.#_(Object.fromEntries(shipping.map(n => [n.key, 0])), shipping, 'remove');
        return;
      }
      if (!a.find((n) => this.#e(n) === g)) {
        let n = this.dataset.returnVariantId;
        if (!n)
          throw new Error("Der R\xFCckversand ist derzeit nicht verf\xFCgbar.");
        await this.#k("add", n, "return-shipping");
        return;
      }
      let i = {};
      const returns = a.filter(n => this.#e(n) === g);
      const keep = returns.find(n => n.properties?._reparablo_weight_confirmed === String(n.variant_id || n.id)) || returns[0];
      for (let n of a) {
        if (this.#e(n) === g && n.key !== keep?.key) i[n.key] = 0;
        else if (n.quantity !== 1) i[n.key] = 1;
      }
      Object.keys(i).length > 0 && (await this.#_(i, a, "update"));
      const normalized = await this.#i();
      const synchronized = await this.#syncInbound(normalized, String(keep.variant_id || keep.id));
      if (synchronized) {
        const refreshed = await this.#t('update', { sections: this.#h(), sections_url: window.location.pathname });
        this.#d(await this.#i(), refreshed.sections, 'inbound-weight');
      }
    }, "#normalizeCart");
    async #syncInbound(cart, returnId) {
      const lines = cart.items.filter(item => this.#e(item) === 'hinversandlabel');
      if (!lines.length) return false;
      const option = Array.from(this.querySelectorAll('[data-return-weight] option')).find(item => item.value === returnId);
      const inboundId = option?.dataset.inboundId;
      if (!inboundId) throw new Error('Für dieses Gewicht ist derzeit kein Hinversandlabel verfügbar.');
      if (lines.length === 1 && String(lines[0].variant_id || lines[0].id) === inboundId && lines[0].quantity === 1) return false;
      const matching = lines.find(item => String(item.variant_id || item.id) === inboundId);
      if (!matching) await this.#t('add', { items: [{ id: Number(inboundId), quantity: 1 }] });
      await this.#t('update', { updates: Object.fromEntries(lines.map(item => [item.key, item === matching ? 1 : 0])) });
      return true;
    }
    #p() {
      return Array.from(this.querySelectorAll("[data-return-weight] option"))
        .map((e) => e.value)
        .filter(Boolean);
    }
    #w(e) {
      const t =
          this.dataset.weightRequired === "true" &&
          e.items.some((i) => !h.has(this.#e(i))),
        a = t ? f(e, this.#p()) : "";
      (document.documentElement.classList.toggle(
        "reparablo-weight-pending",
        t && !a,
      ),
        document.querySelectorAll("[data-return-weight]").forEach((i) => {
          i.value = a;
        }),
        this.#u());
    }
    #f = async (e) => {
      if (
        !(e.target instanceof HTMLSelectElement) ||
        !e.target.matches("[data-return-weight]") ||
        window.__reparabloWeightChange
      )
        return;
      const t = e.target.value;
      if (
        (document.documentElement.classList.add("reparablo-weight-pending"),
        this.#a(!0),
        !t)
      ) {
        this.#a(!1);
        return;
      }
      const a = this.#p(),
        i = this.#h();
      document.querySelectorAll("[data-return-weight]").forEach((o) => {
        o.disabled = !0;
      });
      const n = d.createPromise(),
        r = this,
        s = (async () => {
          window.__reparabloCartNormalization &&
            (await window.__reparabloCartNormalization);
          const o = await this.#i(),
            c = E(o, t, a);
          await this.#t("update", { updates: c.remove, attributes: { 'Rückgabe': t === 'pickup' ? 'Vor Ort – kein Versand' : 'Rückversand' } });
          if (!c.pickup) await this.#syncInbound(o, t);
          const p = { sections: i, sections_url: window.location.pathname },
            y = c.pickup ? await this.#t('update', p) : c.existing
              ? await this.#t("change", {
                  ...p,
                  id: c.existing.key,
                  quantity: 1,
                  properties: c.properties,
                })
              : await this.#t("add", {
                  ...p,
                  items: [
                    { id: Number(t), quantity: 1, properties: c.properties },
                  ],
                }),
            m = await this.#i();
          if (f(m, a) !== t) throw new Error(this.dataset.weightError);
          return (this.#w(m), this.#d(m, y.sections, "return-weight"));
        })();
      ((window.__reparabloWeightChange = s),
        this.dispatchEvent(
          new d({
            action: "update",
            context: "cart",
            lines: [],
            promise: n.promise,
          }),
        ));
      try {
        const o = await s;
        (n.resolve(o),
          document.querySelectorAll("[data-weight-error]").forEach((c) => {
            c.hidden = !0;
          }));
      } catch (o) {
        (n.reject(o),
          document.documentElement.classList.add("reparablo-weight-pending"),
          document.querySelectorAll("[data-weight-error]").forEach((c) => {
            c.hidden = !1;
          }),
          r.#m(o));
      } finally {
        (window.__reparabloWeightChange === s &&
          (window.__reparabloWeightChange = null),
          document.querySelectorAll("[data-return-weight]").forEach((o) => {
            o.disabled = !1;
          }),
          this.#a(!1));
      }
    };
    #b = l(async (e) => {
      if (
        !(e.target instanceof HTMLFormElement) ||
        !e.target.matches("[data-cart-service-form]") ||
        (e.preventDefault(), this.#s)
      )
        return;
      let t = e.target,
        a = t.dataset.action === "remove" ? "remove" : "add",
        i = t.dataset.service || "service",
        n = String(new FormData(t).get("id") || "");
      if (n) {
        ((this.#s = !0), this.#q(t, !0), this.#W());
        try {
          if (
            (await this.#k(a, n, i), t.hasAttribute("data-close-on-success"))
          ) {
            let r = t.closest("dialog");
            r instanceof HTMLDialogElement && r.open && r.close("accepted");
          }
        } catch (r) {
          this.#A(r, "Die Auswahl konnte nicht aktualisiert werden.");
        } finally {
          ((this.#s = !1), t.isConnected && this.#q(t, !1));
        }
      }
    }, "#handleSubmit");
    #y = l((e) => {
      if (!(e.target instanceof Element)) return;
      let t = e.target.closest("[data-express-decline]");
      if (!t) return;
      let a = t.closest("dialog");
      a instanceof HTMLDialogElement && a.open && a.close("declined");
    }, "#handleClick");
    #E = l(async (e) => {
      if (
        !(e.target instanceof HTMLInputElement) ||
        !e.target.matches("[data-legal-master], [data-legal-item]") ||
        this.#g
      )
        return;
      let t = this.#c();
      e.target.matches("[data-legal-master]") &&
        t.forEach((i) => {
          i.checked = e.target.checked;
        });
      let a = this.#v(t);
      (this.#l(a), this.#r(!0), this.#L(!0), this.#M());
      try {
        (await this.#t("update", { attributes: a.attributes }),
          this.#r(!a.complete),
          this.#l(a));
      } catch (i) {
        (this.#r(!0), this.#S(i));
      } finally {
        this.#L(!1);
      }
    }, "#handleLegalChange");
    #n = l((e) => {
      let t = document.documentElement.classList.contains(
          "reparablo-cart-syncing",
        ),
        a = document.documentElement.classList.contains(
          "reparablo-legal-pending",
        );
      const i = document.documentElement.classList.contains(
        "reparablo-weight-pending",
      );
      (!t && !a && !i) ||
        !(e.target instanceof Element) ||
        !e.target.closest(
          '[name="checkout"], .cart__checkout-button, .additional-checkout-buttons',
        ) ||
        (e.preventDefault(),
        e.stopImmediatePropagation(),
        a && this.#S(),
        i && this.querySelector("[data-return-weight]")?.focus());
    }, "#guardCheckout");
    #j() {
      let e = this.#c();
      if (e.length === 0) {
        this.#r(!1);
        return;
      }
      let t = this.#v(e);
      (this.#l(t), this.#r(!t.complete));
    }
    #c() {
      return Array.from(this.querySelectorAll("[data-legal-item]")).filter(
        (e) => e instanceof HTMLInputElement,
      );
    }
    #v(e = this.#c()) {
      let t = {};
      for (let a of e) {
        let i = a.dataset.cartAttribute;
        i && (t[i] = a.checked ? a.dataset.cartValue || "Best\xE4tigt" : "");
      }
      return {
        attributes: t,
        checked: Object.fromEntries(
          e.map((a) => [a.dataset.legalKey || "", a.checked]),
        ),
        complete: e.length > 0 && e.every((a) => a.checked),
      };
    }
    #l(e) {
      (document.querySelectorAll("[data-legal-item]").forEach((t) => {
        if (!(t instanceof HTMLInputElement)) return;
        let a = t.dataset.legalKey || "";
        t.checked = !!e.checked[a];
      }),
        document.querySelectorAll("[data-legal-consent]").forEach((t) => {
          let a = Array.from(t.querySelectorAll("[data-legal-item]")).filter(
              (s) => s instanceof HTMLInputElement,
            ),
            i = a.length > 0 && a.every((s) => s.checked),
            n = a.filter((s) => s.checked).length,
            r = t.querySelector("[data-legal-master]");
          (r instanceof HTMLInputElement &&
            ((r.checked = i), (r.indeterminate = n > 0 && !i)),
            t.classList.toggle("cart-services__legal--complete", i));
        }));
    }
    #x(e) {
      if (
        document.documentElement.classList.contains(
          "reparablo-weight-pending",
        ) ||
        e.items.some((r) => this.#e(r) === _)
      )
        return;
      let t = e.items.find((r) => this.#e(r) === g);
      if (!t || t.properties?.[b] === "1") return;
      let a = String(e.token || this.dataset.cartToken || "current-cart");
      if (u.has(a)) return;
      let i = 0,
        n = l(async () => {
          if (!this.isConnected || i >= 480) return;
          i += 1;
          let r = this.querySelector("[data-express-prompt]");
          if (r instanceof HTMLDialogElement) {
            if (!this.#I()) {
              this.#o = window.setTimeout(n, 250);
              return;
            }
            if (!u.has(a)) {
              u.add(a);
              try {
                await this.#D(t);
              } catch {
                u.add(a);
              }
              r.open || r.showModal();
            }
          }
        }, "tryOpen");
      this.#o = window.setTimeout(n, 120);
    }
    #I() {
      let e = (window.Theme?.routes?.cart_url || "/cart").replace(/\/$/, "");
      if (window.location.pathname.replace(/\/$/, "") === e) return !0;
      let t = this.getBoundingClientRect(),
        a = window.getComputedStyle(this);
      return (
        a.display !== "none" &&
        a.visibility !== "hidden" &&
        Number(a.opacity || 1) > 0 &&
        t.width > 0 &&
        t.height > 0 &&
        t.bottom > 0 &&
        t.right > 0 &&
        t.top < window.innerHeight &&
        t.left < window.innerWidth
      );
    }
    async #D(e) {
      await this.#t("change", {
        id: e.key,
        quantity: 1,
        properties: { ...(e.properties || {}), [b]: "1" },
      });
    }
    async #k(e, t, a) {
      let i = this.#h(),
        n = d.createPromise(),
        r = e === "add";
      this.dispatchEvent(
        new d({
          action: e,
          context: "cart",
          lines: r
            ? [{ merchandiseId: t, quantity: 1 }]
            : [{ id: t, quantity: 0 }],
          promise: n.promise,
        }),
      );
      let s = r
        ? {
            items: [{ id: Number(t), quantity: 1 }],
            sections: i,
            sections_url: window.location.pathname,
          }
        : {
            id: t,
            quantity: 0,
            sections: i,
            sections_url: window.location.pathname,
          };
      try {
        let o = await this.#t(r ? "add" : "change", s),
          c = await this.#i();
        return (n.resolve(this.#d(c, o.sections, a)), c);
      } catch (o) {
        throw (n.reject(o), this.#m(o), o);
      }
    }
    async #_(e, t, a) {
      let i = this.#h(),
        n = d.createPromise();
      this.dispatchEvent(
        new d({
          action: a,
          context: "cart",
          lines: t.map((r) => ({
            id: r.key,
            quantity: Number(e[r.key] ?? r.quantity),
          })),
          promise: n.promise,
        }),
      );
      try {
        let r = await this.#t("update", {
            updates: e,
            sections: i,
            sections_url: window.location.pathname,
          }),
          s = await this.#i();
        return (
          n.resolve(this.#d(s, r.sections, "cart-services-normalization")),
          s
        );
      } catch (r) {
        throw (n.reject(r), this.#m(r), r);
      }
    }
    async #t(e, t) {
      let a = window.Theme?.routes || {},
        i = window.Shopify?.routes?.root || "/",
        n = {
          add: a.cart_add_url || `${i}cart/add.js`,
          change: a.cart_change_url || `${i}cart/change.js`,
          update: a.cart_update_url || `${i}cart/update.js`,
        },
        r = await fetch(n[e], {
          method: "POST",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(t),
        }),
        s = await r.json();
      if (!r.ok || s.status || s.errors)
        throw new Error(
          s.description ||
            s.message ||
            s.errors ||
            "Der Warenkorb konnte nicht aktualisiert werden.",
        );
      return s;
    }
    async #i() {
      let e =
          window.Theme?.routes?.cart_url ||
          `${window.Shopify?.routes?.root || "/"}cart`,
        t = await fetch(`${e}.js`, {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        });
      if (!t.ok) throw new Error("Der Warenkorb konnte nicht geladen werden.");
      return t.json();
    }
    #d(e, t, a) {
      return {
        cart: d.createCartFromAjaxResponse(e),
        detail: {
          sections: t,
          items: e.items,
          itemCount: e.item_count,
          source: a,
          didError: !1,
        },
      };
    }
    #h() {
      let e = new Set();
      return (
        document
          .querySelectorAll("cart-items-component[data-section-id]")
          .forEach((t) => {
            t instanceof HTMLElement &&
              t.dataset.sectionId &&
              e.add(t.dataset.sectionId);
          }),
        this.dataset.sectionId && e.add(this.dataset.sectionId),
        Array.from(e)
      );
    }
    #e(e) {
      return String(e.handle || e.product_handle || "").split("?")[0];
    }
    #a(e) {
      (document.documentElement.classList.toggle("reparablo-cart-syncing", e),
        this.#u());
    }
    #r(e) {
      (document.documentElement.classList.toggle("reparablo-legal-pending", e),
        this.#u());
    }
    #u() {
      let e = document.documentElement.classList.contains(
          "reparablo-cart-syncing",
        ),
        t = document.documentElement.classList.contains(
          "reparablo-legal-pending",
        ),
        a =
          e ||
          t ||
          document.documentElement.classList.contains(
            "reparablo-weight-pending",
          );
      document
        .querySelectorAll('button[name="checkout"], .cart__checkout-button')
        .forEach((i) => {
          i instanceof HTMLButtonElement &&
            (a
              ? (i.dataset.reparabloWasDisabled === void 0 &&
                  (i.dataset.reparabloWasDisabled = i.disabled
                    ? "true"
                    : "false"),
                (i.disabled = !0),
                i.setAttribute("aria-disabled", "true"),
                i.toggleAttribute("aria-busy", e))
              : i.dataset.reparabloWasDisabled !== void 0 &&
                ((i.disabled = i.dataset.reparabloWasDisabled === "true"),
                i.removeAttribute("aria-disabled"),
                i.removeAttribute("aria-busy"),
                delete i.dataset.reparabloWasDisabled));
        });
    }
    #L(e) {
      ((this.#g = e),
        document
          .querySelectorAll("[data-legal-master], [data-legal-item]")
          .forEach((t) => {
            t instanceof HTMLInputElement &&
              ((t.disabled = e), t.toggleAttribute("aria-busy", e));
          }));
    }
    #M() {
      document.querySelectorAll("[data-legal-error]").forEach((e) => {
        e.hidden = !0;
      });
    }
    #S(e) {
      let t =
          this.querySelector("[data-legal-error]")?.dataset.defaultMessage ||
          "Bitte best\xE4tige alle erforderlichen Punkte.",
        a = e instanceof Error ? `${e.message} Bitte versuche es erneut.` : t;
      (document.querySelectorAll("[data-legal-error]").forEach((i) => {
        ((i.textContent = a), (i.hidden = !1));
      }),
        this.querySelector("[data-legal-consent]")?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        }));
    }
    #q(e, t) {
      e.querySelectorAll("button").forEach((a) => {
        ((a.disabled = t), a.toggleAttribute("aria-busy", t));
      });
    }
    #W() {
      this.querySelectorAll("[data-cart-services-error]").forEach((e) => {
        ((e.hidden = !0), (e.textContent = ""));
      });
    }
    #A(e, t) {
      let a = e instanceof Error ? e.message : t;
      this.querySelectorAll("[data-cart-services-error]").forEach((i) => {
        ((i.textContent = `${a || t} Bitte versuche es erneut.`),
          (i.hidden = !1));
      });
    }
    #m(e) {
      let t =
        e instanceof Error
          ? e.message
          : "Der Warenkorb konnte nicht aktualisiert werden.";
      this.dispatchEvent(new v({ error: t, code: "SERVICE_UNAVAILABLE" }));
    }
  };
customElements.get("cart-services") ||
  customElements.define("cart-services", L);
